import React from 'react';
import Navbar from '@components/Fellowship/Navbar/Navbar';
import Hero from '@components/Fellowship/Hero/Hero';
import StatsBar from '@components/Fellowship/StatsBar/StatsBar';
import TrustedBy from '@components/Fellowship/TrustedBy/TrustedBy';
import About from '@components/Fellowship/About/About';
import Themes from '@components/Fellowship/Themes/Themes';
import HowItWorks from '@components/Fellowship/HowItWorks/HowItWorks';
import Timeline from '@components/Fellowship/Timeline/Timeline';
import MentorsAndAdvisors from '@components/Fellowship/MentorsAndAdvisors/MentorsAndAdvisors';
import Outcomes from '@components/Fellowship/Outcomes/Outcomes';
import Comparison from '@components/Fellowship/Comparison/Comparison';
import ApplicationForm from '@components/Fellowship/ApplicationForm/ApplicationForm';
import Testimonials from '@components/Fellowship/Testimonials/Testimonials';
import FAQ from '@components/Fellowship/FAQ/FAQ';
import Footer from '@components/Fellowship/Footer/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="bg-[#0B061A] text-slate-100 min-h-screen font-sans selection:bg-pink-500 selection:text-white">
      <Navbar />
      <Hero />
      {/* <StatsBar /> */}
      <TrustedBy />
      <main className="bg-white text-slate-900 transition-colors">
        <About />
        <StatsBar />
        <Themes />
        <HowItWorks />
        <Timeline />
        <Testimonials />
        <MentorsAndAdvisors />
        <Comparison />
        <Outcomes />
        <FAQ />
        <ApplicationForm />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
